import { ReactNode } from 'react';

import { LABEL_CLASSES, LABEL_TYPE } from './label-config';

export type LabelProps = {
  type?: string;
  text?: string | ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
};

export const Label = ({
  type = LABEL_TYPE.PARAGRAPH1,
  text = '',
  className = '',
  onClick
}: LabelProps) => {
  return (
    <div className={`${LABEL_CLASSES[type]} ${className}`} onClick={onClick}>
      {text}
    </div>
  );
};
